export default "__VITE_ASSET__Cgl97_re__"